import { CallConfirmationModal } from "@/components/group-call/call-confirmation-modal.tsx";
import { useActiveCallNotification } from "@/lib/hooks/conversations/useActiveCallNotification";
import { cn } from "@/lib/utils.ts";
import { PhoneCallIcon, Video } from "lucide-react";
import { useState } from "react";

interface CallButtonProps {
  otherUserId: string;
  isSupervisorChannel?: boolean;
}

export function CallButton({
  otherUserId,
  isSupervisorChannel,
}: CallButtonProps) {
  const [open, setOpen] = useState(false);
  useActiveCallNotification(otherUserId);

  return (
    <>
      <button
        className={cn(
          isSupervisorChannel
            ? "inline-flex h-12 items-center justify-center gap-2 rounded-lg border p-3 hover:bg-[#e1e1e1] active:bg-[#e1e1e1] disabled:cursor-not-allowed disabled:bg-[#f1f1f1]"
            : "mr-2 flex h-12 w-12 items-center justify-center rounded-xl border border-gray-400 text-gray-400 hover:border-blue-500 hover:bg-blue-100 hover:text-blue-500 active:bg-blue-200 active:text-blue-600 disabled:cursor-not-allowed disabled:border-gray-400 disabled:bg-gray-100 disabled:text-gray-400",
        )}
        onClick={() => setOpen(true)}
      >
        {isSupervisorChannel ? (
          <Video className="h-6 w-6" />
        ) : (
          <PhoneCallIcon />
        )}
      </button>
      <CallConfirmationModal
        otherUserId={otherUserId}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
